/** @format */

import { ReactNode } from "react";
import { useHistory } from "react-router";
import Logout from "components/Logout";
import NotificationsPopover from "features/notifications/header/NotificationsPopover";
import { Header, HeaderActions, PageTitle } from "pages/style";

type PageHeaderProps = {
  title: ReactNode;
};

const PageHeader = ({ title }: PageHeaderProps) => {
  const history = useHistory();

  return (
    <>
      <Header>
        <HeaderActions>
          <NotificationsPopover
            onDisplayAll={() => history.push("/notifications")}
          />
          <Logout />
        </HeaderActions>
      </Header>
      <PageTitle>{title}</PageTitle>
    </>
  );
};

export default PageHeader;
